export const FIELD_TO_AUTO_ANOMALIES_COLUMN_TITLE_KEY: Record<string, string> = {
  anomalyAt: 'alertsManagerWidget:autoAnomalies.column.eventDate',
  eventTime: 'alertsManagerWidget:autoAnomalies.column.eventTime',
  wellboreId: 'alertsManagerWidget:autoAnomalies.column.wellboreName',
  riskLevel: 'alertsManagerWidget:autoAnomalies.column.riskLevel',
  updatedBy: 'alertsManagerWidget:autoAnomalies.column.author',
  anomalyTypeGroup: 'alertsManagerWidget:autoAnomalies.column.anomalyTypeGroup',
  anomalyTypeId: 'alertsManagerWidget:autoAnomalies.column.anomalyType',
  anomalySubtypeId: 'alertsManagerWidget:autoAnomalies.column.anomalySubtype',
  indexType: 'alertsManagerWidget:autoAnomalies.column.indexFormat',
  sourceType: 'alertsManagerWidget:autoAnomalies.column.dataType',
  sourceOption: 'alertsManagerWidget:autoAnomalies.column.parameter',
  holeDepth: 'alertsManagerWidget:autoAnomalies.column.holeDepth',
  bitDepth: 'alertsManagerWidget:autoAnomalies.column.bitDepth',
  limitType: 'alertsManagerWidget:autoAnomalies.column.limitType',
  unitId: 'alertsManagerWidget:autoAnomalies.column.unit',
  referenceParameterName: 'alertsManagerWidget:autoAnomalies.column.referenceParameterName',
  valueGroup: 'alertsManagerWidget:autoAnomalies.column.valueGroup',
  valueFact: 'alertsManagerWidget:autoAnomalies.column.valueFact',
  valueLimit: 'alertsManagerWidget:autoAnomalies.column.valueLimit',
  deltaGroup: 'alertsManagerWidget:autoAnomalies.column.deltaGroup',
  valueAbsoluteDiff: 'alertsManagerWidget:autoAnomalies.column.valueAbsoluteDiff',
  valueRelativeDiff: 'alertsManagerWidget:autoAnomalies.column.valueRelativeDiff',
  deltaRelative: 'alertsManagerWidget:autoAnomalies.column.deltaRelative',
  notification: 'alertsManagerWidget:autoAnomalies.column.notification',
  recommendation: 'alertsManagerWidget:autoAnomalies.column.recommendation',
  stageTypeId: 'alertsManagerWidget:contextTitle.stage',
  wellboreTypeId: 'alertsManagerWidget:contextTitle.wellboreType',
  trajectoryTypeId: 'alertsManagerWidget:contextTitle.trajectoryType',
  sectionTypeId: 'alertsManagerWidget:contextTitle.section',
  holeType: 'alertsManagerWidget:contextTitle.holeType',
  stratUnitTypeId: 'alertsManagerWidget:contextTitle.stratUnit',
  reservoirId: 'alertsManagerWidget:contextTitle.reservoir',
  runTypeId: 'alertsManagerWidget:contextTitle.run',
  operationTypeId: 'alertsManagerWidget:contextTitle.operation',
} as const;

export const AUTO_ANOMALIES_CONTEXT_COLUMN_FIELDS: string[] = [
  'stageTypeId',
  'wellboreTypeId',
  'trajectoryTypeId',
  'sectionTypeId',
  'holeType',
  'stratUnitTypeId',
  'reservoirId',
  'runTypeId',
  'operationTypeId',
];
